import { Spin } from 'antd';
import { useGetDocumentaryActivityOffices } from 'client/api/backend/documentary-activity/documentary-activity';
import {
  SelectInput,
  SelectInputProps
} from 'client/ui/form/input/SelectInput';
import * as React from 'react';

interface IActivityOfficesSelectInputProps extends SelectInputProps<any> {
  widgetId: number;
}

export function ActivityOfficesSelectInput(
  props: IActivityOfficesSelectInputProps
) {
  const { widgetId, ...otherProps } = props;

  const officesResult = useGetDocumentaryActivityOffices({ widgetId });

  return (
    <SelectInput
      allowClear
      showSearch
      optionFilterProp="label"
      loading={officesResult.isLoading}
      notFoundContent={
        officesResult.isLoading ? (
          <Spin size="small" />
        ) : (
          'Nessun elemento trovato.'
        )
      }
      options={officesResult.data?.map(office => ({
        label: office.name ?? `Ufficio ${office.code!}`,
        value: office.code!
      }))}
      {...otherProps}
    />
  );
}
